import React from 'react';

type IconProps = {
  w?: number;
  h?: number;
  className?: string;
};

const TPayIcon = ({ w = 58, h = 24, className }: IconProps) => {
  return (
    <svg
      width={w}
      height={h}
      viewBox="0 0 58 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M45.9996 0H12.2422C5.61477 0 0.242188 5.37258 0.242188 12C0.242188 18.6274 5.61477 24 12.2422 24H45.9996C52.627 24 57.9996 18.6274 57.9996 12C57.9996 5.37258 52.627 0 45.9996 0Z"
        fill="#303030"
      />
      <path
        d="M29.9219 8.4455H25.1328V16.0944H27.4622V14.0368H29.92C30.4976 14.0368 31.0601 14.0198 31.6076 13.8443C32.6684 13.5064 33.4556 12.5588 33.4556 11.2732C33.4556 9.98773 32.6835 9.05522 31.6397 8.68712C31.062 8.47759 30.5146 8.4455 29.92 8.4455H29.9219ZM27.4641 12.2379V10.2935H29.5859C30.0351 10.2935 30.2937 10.3426 30.5014 10.4219C30.8714 10.5673 31.0469 10.9033 31.0469 11.2581C31.0469 11.6432 30.8374 12.0132 30.4372 12.1416C30.2447 12.2058 30.02 12.2379 29.5859 12.2379H27.4641Z"
        fill="white"
      />
      <path
        d="M36.7973 13.2987L37.9054 10.2143H38.0828L39.1909 13.2987H36.7973ZM36.2197 14.9863H39.7553L40.2046 16.0944H42.8228L39.6893 8.4455H36.282L33.1484 16.0944H35.7836L36.2178 14.9863H36.2197Z"
        fill="white"
      />
      <path
        d="M48.4937 8.4455L46.5985 11.932H46.5173L44.6051 8.4455H41.8906L45.3451 14.0689V16.0944H47.7557V13.8764L51.0346 8.4455H48.4937Z"
        fill="white"
      />
      <path
        d="M7.21289 6.17645H20.1548V12.6852C20.1548 14.3539 19.2639 15.8961 17.8198 16.7305L13.6839 19.1184L9.54795 16.7305C8.10199 15.8961 7.21289 14.3539 7.21289 12.6852V6.17645Z"
        fill="#FFDD2D"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.7636 9.6026V11.6262C11.0411 11.3128 11.5432 11.1014 12.119 11.1014H12.7438V13.4554C12.7438 14.0821 12.5739 14.6295 12.3209 14.9315H15.0411C14.79 14.6295 14.6201 14.0821 14.6201 13.4572V11.1033H15.245C15.8207 11.1033 16.3247 11.3147 16.6003 11.6281V9.60449H10.7617L10.7636 9.6026Z"
        fill="#333333"
      />
    </svg>
  );
};

export default TPayIcon;
